import { AlertOptions, useAppAlert } from '@/app/AppAlertProvider.tsx'
import {
  DOCUMENT_TYPES,
  DOCUMENT_VARIANTS,
} from '@/app/common/components/document-upload-new.constants'
import DocumentPreviewNew from '@/app/common/components/Documents/DocumentPreviewNew'
import useDocumentUpload from '@/app/common/components/useDocumentUploadNew'
import { parseRequestError } from '@/app/common/utilities'
import { useWizardContext } from '@/app/pages/family_application/income_verification/IncomeVerificationWizardProvider.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import {
  RefreshFamilyApplication
} from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { AppDispatch } from '@/storage/store.ts'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

export const ResidencyDocumentReview = () => {
  const { t: translate } = useTranslation()
  const programId = useSelector(selectProgramID)
  const { formData } = useWizardContext()
  const { status, mutate } = useDocumentUpload({
    variation: DOCUMENT_VARIANTS.IDENTITY_ID_CARD,
    type: DOCUMENT_TYPES.IDENTITY_ID,
    referer_page: "manual_residency_verification",
    onSuccess: async (response) => {
      let documentSubmittedPath:string =
        AppRoutePaths.family_application.residency_verification.enter_details

      if(response?.ocr?.ocr_response?.errors != undefined && response.ocr.ocr_response.errors.length > 0) {
        fireAlert({
          variant: 'error',
          titleText: translate('residency'),
          messageComponent: (
              <>
                <p className="text-sm text-center mb-2">{translate('ocr_do_not_match')}</p>
                <p className=" text-center text-sm mt-1 text-gray-800">
                  {translate('support_review_docs')}
                </p>
              </>
          ),
          denyBtn: true,
          denyBtnText: translate('retry'),
          confirmBtnText: translate('confirm'),
        }).then(({ confirmed, denied }) => {
          if (confirmed) {
            dispatch(RefreshFamilyApplication(programId))
            navigateTo(documentSubmittedPath)
          }
          if (denied) {
            navigateTo(AppRoutePaths.family_application.residency_verification
                .document_capture
            )
            return false;
          }
        })
      } else {
        if(response?.ocr?.residency_validated != undefined && response.ocr.residency_validated) {
          documentSubmittedPath =
              AppRoutePaths.family_application.residency_verification.success_verification
        } 
        dispatch(RefreshFamilyApplication(programId))
        navigateTo(documentSubmittedPath)
      }
    },
    onError: (error: unknown) => {
      const parsedError = parseRequestError(error)

      const alertConfig: AlertOptions = {
        variant: 'error',
        message:
          parsedError.message ||
          translate('an_error_occurred_whil_processing_the_document'),
        denyBtn: true,
        denyBtnText: translate('retry'),
      }

      fireAlert(alertConfig).then(({ denied }) => {
        if (denied) {
          navigateTo(-1)
        }
      })
    },
  })

  const { fireAlert } = useAppAlert()

  const navigateTo = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  return (
    <>
      <div className="text-3xl text-center font-medium text-gray-900 mb-10 sm:mb-5">
        {translate('photo_review')}
      </div>

      <div className="flex justify-center">
        <DocumentPreviewNew
          status={status}
          file={formData.DateOfBirthFile}
          onRetakeClick={() => {
            navigateTo(
              AppRoutePaths.family_application.residency_verification
                .document_capture
            )
          }}
          onContinueClick={(file) => {
            mutate(file)
          }}
        />
      </div>
    </>
  )
}
